
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../node_modules/core-js/modules/es.array.map.js';
import { Children, cloneElement } from 'react';
import { createElement as jsx, ClassNames } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';
import ReactModal from '../../../node_modules/react-modal/lib/index.js';
import Heading from '../Heading/Heading.js';
import SvgCloseModal from '../../icons/legacy/close-modal.svg.js';
import { modalHeader, modalContent, modalFooter, portalStyles } from './styles.js';

var _excluded = ["children", "onClose"],
  _excluded2 = ["children"],
  _excluded3 = ["children"];
var Header = function Header(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    rest = _objectWithoutProperties(_ref, _excluded);
  var title = typeof children === "string" ? jsx(Heading, {
    size: "md"
  }, children) : children;
  return jsx("header", _extends({
    css: modalHeader,
    "data-testid": "modal-header"
  }, rest), jsx("div", null, title), onClose && jsx("button", {
    role: "button",
    className: "close-btn",
    "aria-label": "Close button",
    "data-testid": "header-close-button",
    onClick: onClose
  }, jsx(SvgCloseModal, {
    height: 32
  })));
};
var Body = function Body(_ref2) {
  var children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return jsx("article", _extends({
    css: modalContent
  }, rest), children);
};
var Footer = function Footer(_ref3) {
  var children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return jsx("footer", _extends({
    css: modalFooter,
    "data-testid": "modal-footer"
  }, rest), children);
};

//opacity is set 0.7 default

var Modal = function Modal(_ref4) {
  var children = _ref4.children,
    isOpen = _ref4.isOpen,
    onClose = _ref4.onClose,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? "sm" : _ref4$size,
    _ref4$rootElementSele = _ref4.rootElementSelector,
    rootElementSelector = _ref4$rootElementSele === void 0 ? "#app" : _ref4$rootElementSele,
    _ref4$closeOnOutsideC = _ref4.closeOnOutsideClick,
    closeOnOutsideClick = _ref4$closeOnOutsideC === void 0 ? true : _ref4$closeOnOutsideC,
    style = _ref4.style,
    onAfterOpen = _ref4.onAfterOpen;
  var rootElement = document.querySelector(rootElementSelector);
  var clonedChildren = Children.map(children, function (child) {
    return /*#__PURE__*/cloneElement(child, {
      onClose: onClose
    });
  });
  return jsx(ClassNames, null, function (_ref5) {
    var css = _ref5.css;
    return jsx(ReactModal, {
      isOpen: isOpen,
      appElement: rootElement,
      onRequestClose: onClose,
      onAfterOpen: onAfterOpen,
      contentLabel: "modal",
      overlayClassName: {
        base: "overlay-base",
        afterOpen: "overlay-after",
        beforeClose: "overlay-before"
      },
      className: {
        base: "content-base",
        afterOpen: "content-after",
        beforeClose: "content-before"
      },
      closeTimeoutMS: 200,
      portalClassName: css(portalStyles(size)),
      ariaHideApp: false,
      shouldCloseOnOverlayClick: closeOnOutsideClick,
      style: style
    }, clonedChildren);
  });
};
Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;

export { Modal as default };
//# sourceMappingURL=Modal.js.map
